import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['row', 'group', 'groupCount', 'totalCount', 'empty']

  search(event) {
    clearTimeout(this._debounce)
    this._debounce = setTimeout(() => this._filter(event.target.value), 300)
  }

  _filter(query) {
    const normalizedQuery = query.trim().toLowerCase()
    const isSearching = normalizedQuery !== ''

    this._saveOriginalStates()

    this.rowTargets.forEach((row) => {
      const text = row.textContent.toLowerCase()
      row.classList.toggle('hidden', isSearching && !text.includes(normalizedQuery))
    })

    let totalVisible = 0

    this.groupTargets.forEach((group, index) => {
      const details = group.querySelector('details')
      const rows = group.querySelectorAll('[data-user-search-target="row"]')
      const visibleCount = Array.from(rows).filter((r) => !r.classList.contains('hidden')).length
      const isEmpty = visibleCount === 0

      group.classList.toggle('hidden', isEmpty)

      if (details) {
        details.open = isSearching ? !isEmpty : (this._originalStates?.[index] ?? false)
      }

      if (this.groupCountTargets[index]) {
        this.groupCountTargets[index].textContent = visibleCount
      }

      totalVisible += visibleCount
    })

    this.totalCountTarget.textContent = `${totalVisible} usuário(s) ativo(s)`
    this.emptyTarget.classList.toggle('hidden', totalVisible > 0)
  }

  _saveOriginalStates() {
    if (this._originalStates) return

    this._originalStates = this.groupTargets.map((group) => {
      const details = group.querySelector('details')
      return details ? details.open : false
    })
  }
}
